<template>
  <div>
    <ejs-dialog ref="dialog" v-bind="dialogProps" @close="onDialogClose">
      <div
        class="typePos"
        :style="{
          minWidth: `${dialogProps.width}px`,
          minHeight: `${dialogProps.height - 66}px`,
        }"
      >
        <div class="typePos-wrapper-caption">
          <div class="typePos-header">
            <div class="typePos-filed typePos-code">
              <div class="typePos-filed-content">
                <div class="typePos-item">
                  <f-select
                    class="ui-select"
                    :items="commonDepthOneProductCategoriesForSelect"
                    v-model="selectedCommonDepthOneProductCategoryId"
                  />
                </div>
                <div class="typePos-item">
                  <f-select
                    class="ui-select"
                    :items="commonDepthTwoProductCategoriesForSelect"
                    v-model="selectedCommonDepthTwoProductCategoryId"
                  />
                </div>
                <div class="typePos-item">
                  <f-select
                    class="ui-select"
                    :items="commonDepthThreeProductCategoriesForSelect"
                    v-model="selectedCommonDepthThreeProductCategoryId"
                  />
                </div>
                <div class="typePos-item">
                  <div class="ui-input">
                    <!-- 비활성(Attribute) : disabled -->
                    <input
                      ref="input-q"
                      type="text"
                      placeholder="상품명, 상품코드"
                      v-model="productNameCode"
                      @keypress.enter="onKeypressEnter"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="typePos-filed">
              <div class="typePos-filed-content">
                <div class="typePos-item">
                  <ul class="ui-check">
                    <li>
                      <label>
                        <!-- 비활성(Attribute) : disabled -->
                        <input type="checkbox" v-model="optnFlag" />
                        <div class="i-item">옵션상품</div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="typePos-lookup">
              <!-- 비활성(Attribute) : disabled -->
              <erp-button
                button-div="GET"
                class="ui-button i-typePrimary"
                :use-syncfusion-component-style="false"
                :is-shortcut-button="true"
                :visible-shortcut-string="false"
                @click.native="onSearchClick"
              >
                <div class="i-item">
                  조회 ({{ searchShortcutButtonShortcutString }})
                </div>
              </erp-button>
            </div>
          </div>
        </div>
        <div class="typePos-wrapper-main">
          <ejs-grid-wrapper
            ref="productListGrid"
            v-bind="productListGridProps"
            @queryCellInfo="onProductListGridQueryCellInfo"
            @rowDataBound="onProductListGridRowDataBound"
            @onGridDialogDoubleClickedOrEnterKeyed="
              onProductListGridRecordDoubleClick
            "
            @rowDrop="onProductListGridRowDrop"
            @dataBound="onProductListGridDataBound"
          />
        </div>
        <div class="typePos-wrapper-footer">
          <ul class="typePos-button typePos-button-order" v-if="canEditOrder">
            <template v-if="isOrderEditable">
              <li>
                <erp-button
                  button-div="GET"
                  class="ui-button"
                  :use-syncfusion-component-style="false"
                  @click.native="onMoveUpClick"
                >
                  <div class="i-item">위로</div>
                </erp-button>
              </li>
              <li>
                <erp-button
                  button-div="GET"
                  class="ui-button"
                  :use-syncfusion-component-style="false"
                  @click.native="onMoveDownClick"
                >
                  <div class="i-item">아래로</div>
                </erp-button>
              </li>
              <li>
                <erp-button
                  button-div="GET"
                  class="ui-button"
                  :use-syncfusion-component-style="false"
                  :disabled="!isOrderChanged"
                  @click.native="onRestoreOrderClick"
                >
                  <div class="i-item">되돌리기</div>
                </erp-button>
              </li>
              <li>
                <erp-button
                  button-div="SAVE"
                  class="ui-button i-typePrimary"
                  :use-syncfusion-component-style="false"
                  :disabled="!isOrderChanged"
                  @click.native="onSaveOrderClick"
                >
                  <div class="i-item">순서 저장</div>
                </erp-button>
              </li>
            </template>
            <li v-else class="typePos-order-guide">
              순서 편집은 소분류를 선택하여 조회한 후 사용할 수 있습니다.
            </li>
          </ul>
          <ul class="typePos-button">
            <li>
              <!-- 비활성(Attribute) : disabled -->
              <erp-button
                button-div="SAVE"
                class="ui-button i-typePrimary i-iconConfirm"
                :use-syncfusion-component-style="false"
                @click="onSubmitClick"
              >
                <div class="i-item">확인</div>
              </erp-button>
            </li>
            <li>
              <!-- 비활성(Attribute) : disabled -->
              <erp-button
                button-div="CLOSE"
                class="ui-button i-iconClose"
                :use-syncfusion-component-style="false"
                @click="onCloseClick"
              >
                <div class="i-item">닫기</div>
              </erp-button>
            </li>
          </ul>
        </div>
      </div>
    </ejs-dialog>
  </div>
</template>

<style scoped>
.typePos {display: flex; flex-direction: column; box-sizing: border-box; width: calc(100% + 36px); height: calc(100% + 18px); margin: 0 -18px -18px -18px; border-top: 1px solid #bebebe;}

.typePos .typePos-wrapper-caption {padding: 10px; border-bottom: 1px solid #bebebe;}
.typePos .typePos-wrapper-caption::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed,
.typePos .typePos-wrapper-caption .typePos-lookup {float: left;}
.typePos .typePos-wrapper-caption .typePos-filed {padding: 0 3px;}
.typePos .typePos-wrapper-caption .typePos-lookup {padding: 0 10px;}
.typePos .typePos-wrapper-caption .typePos-filed::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-title,
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content {float: left; padding: 0 7px; color: #666; font-size: 13px; font-family: 'NanumSquare-Regular'; line-height: 19px;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-title {padding-top: 10px; padding-bottom: 11px; color: #222; font-family: 'NanumSquare-Bold';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item {float: left; padding-left: 10px;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item:first-child {padding-left: 0;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-title,
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-content {float: left; padding-top: 10px; padding-bottom: 11px;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-title {padding-right: 4px; color: #222; font-family: 'NanumSquare-Bold';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-content strong {color: #18b3c9; font-weight: normal;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-content em {color: #df2929; font-style: normal;}
.typePos .typePos-wrapper-caption .typePos-lookup >>> .ui-button .i-item::before {background-position-x: calc(-20px * 7);}
.typePos .typePos-wrapper-caption .typePos-header {float: left;}
.typePos .typePos-wrapper-caption .typePos-header::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-header .typePos-filed.typePos-code .typePos-filed-content .typePos-item .ui-select {width: 180px;}
.typePos .typePos-wrapper-caption .typePos-header .typePos-filed.typePos-code .typePos-filed-content .typePos-item .ui-input {width: 180px;}
.typePos .typePos-wrapper-caption .typePos-footer {float: right;}
.typePos .typePos-wrapper-caption .typePos-footer::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}

.typePos .typePos-wrapper-main {flex: 1; overflow: hidden;}

.typePos .typePos-wrapper-main >>> .e-grid .e-gridcontent tr.dev-soldout-row > td.e-rowcell,
.typePos .typePos-wrapper-main >>> .e-grid .e-gridcontent tr.dev-soldout-row:hover > td.e-rowcell,
.typePos .typePos-wrapper-main >>> .e-grid .e-gridcontent tr.dev-soldout-row > td.e-rowcell.e-selectionbackground,
.typePos .typePos-wrapper-main >>> .e-grid .e-gridcontent tr.dev-soldout-row > td.e-rowcell.e-cellselectionbackground,
.typePos .typePos-wrapper-main >>> .e-grid .e-gridcontent tr.dev-soldout-row > td.e-rowcell.e-active {background-color: #e53935 !important; color: #fff !important;}

.typePos .typePos-wrapper-footer {padding: 15px; border-top: 1px solid #bebebe;}
.typePos .typePos-wrapper-footer::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-footer .typePos-button {float: right; list-style: none; padding: 0; margin: 0;}
.typePos .typePos-wrapper-footer .typePos-button::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-footer .typePos-button > li {float: left; padding: 0 5px;}
.typePos .typePos-wrapper-footer .typePos-button.typePos-button-order {float: left;}
.typePos .typePos-wrapper-footer .typePos-button.typePos-button-order .typePos-order-guide {float: left; padding: 8px 5px; color: #999; font-size: 13px; font-family: 'NanumSquare-Regular';}
</style>

<script>
import { getProductList, putProductOrder } from "@/api/storePointOfSaleSystem";
import EjsGridWrapper from "@/components/common/EjsGridWrapper";
import { commonCodesGetColorValue } from "@/utils/commonCodes";
import { ForeignKey, Resize, RowDD } from "@syncfusion/ej2-vue-grids";
import FSelect from "@/views/store-management/sales-registration/store-pos-renew/components/FSelect";
import { sortBy as _sortBy } from "lodash";
import GolfERPService from "@/service/GolfERPService";
import ErpButton from "@/components/button/ErpButton";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import {
  getSearchButtonShortcut,
  toShortcutString,
} from "@/utils/KeyboardUtil";

export default {
  name: "SearchProductsPopup",
  components: { FSelect, EjsGridWrapper, ErpButton },
  mixins: [confirmDialogMixin],
  props: {
    store: {
      type: Object,
      required: true,
    },
    canEditOrder: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    selectedCommonDepthOneProductCategoryId(
      selectedCommonDepthOneProductCategoryId
    ) {
      this.selectedCommonDepthTwoProductCategoryId = "";
      this.selectedCommonDepthThreeProductCategoryId = "";
      this.fetchCommonDepthTwoProductCategories(
        selectedCommonDepthOneProductCategoryId
      );
    },
    selectedCommonDepthTwoProductCategoryId(
      selectedCommonDepthTwoProductCategoryId
    ) {
      this.selectedCommonDepthThreeProductCategoryId = "";
      this.fetchCommonDepthThreeProductCategories(
        selectedCommonDepthTwoProductCategoryId
      );
    },
  },
  data() {
    return {
      selectedCommonDepthOneProductCategoryId: "",
      selectedCommonDepthTwoProductCategoryId: "",
      selectedCommonDepthThreeProductCategoryId: "",
      productNameCode: "",
      optnFlag: false,

      commonDepthOneProductCategories: [],
      commonDepthTwoProductCategories: [],
      commonDepthThreeProductCategories: [],

      products: [],
      // 순서 편집 전 원본 스냅샷 (변경여부 판단 / 복원용)
      originalProducts: [],
      // 마지막 조회에 사용된 소분류 코드 (단일 소분류일 때만 순서 편집 허용)
      fetchedDepth03Code: null,
      // 재배치 후 재선택할 상품코드 (dataBound 에서 사용)
      orderEditSelectProductCode: null,
    };
  },
  computed: {
    searchShortcutButtonShortcutString() {
      return toShortcutString(getSearchButtonShortcut());
    },
    dialogProps() {
      const dialogProps = {
        enableResize: true,
        header: "상품코드 검색",
        width: 1160,
        height: 760,
        allowDragging: true,
        animationSettings: { effect: "None" },
        isModal: true,
        position: { x: "center", y: "center" },
        visible: false,
        showCloseIcon: true,
      };

      if (!dialogProps.height) {
        if (!dialogProps.cssClass) {
          dialogProps.cssClass = "dialog-non-height";
        } else {
          dialogProps.cssClass = `${dialogProps.cssClass} dialog-non-height`;
        }
      }

      return dialogProps;
    },
    commonDepthOneProductCategoriesForSelect() {
      const commonDepthOneProductCategoriesForSelect = this.commonDepthOneProductCategories.map(
        (category) => ({
          name: category.name,
          value: category.code,
        })
      );

      commonDepthOneProductCategoriesForSelect.unshift({
        name: "전체",
        value: "",
      });

      return commonDepthOneProductCategoriesForSelect;
    },
    commonDepthTwoProductCategoriesForSelect() {
      const commonDepthTwoProductCategoriesForSelect = this.commonDepthTwoProductCategories.map(
        (category) => ({
          name: category.name,
          value: category.code,
        })
      );

      commonDepthTwoProductCategoriesForSelect.unshift({
        name: "전체",
        value: "",
      });

      return commonDepthTwoProductCategoriesForSelect;
    },
    commonDepthThreeProductCategoriesForSelect() {
      const commonDepthThreeProductCategoriesForSelect = this.commonDepthThreeProductCategories.map(
        (category) => ({
          name: category.name,
          value: category.code,
        })
      );

      commonDepthThreeProductCategoriesForSelect.unshift({
        name: "전체",
        value: "",
      });

      return commonDepthThreeProductCategoriesForSelect;
    },

    // 순서 편집 가능 여부: 저장권한 + 단일 소분류로 조회 + 목록 존재
    isOrderEditable() {
      return (
        this.canEditOrder &&
        !!this.fetchedDepth03Code &&
        this.products.length > 0
      );
    },
    // 원본 대비 순서 변경 여부
    isOrderChanged() {
      if (this.originalProducts.length !== this.products.length) {
        return false;
      }
      return this.products.some(
        (product, index) =>
          product.productCode !== this.originalProducts[index].productCode
      );
    },

    productListGridProps() {
      const dataSource = !this.products
        ? []
        : this.products.map((record) => ({
            ...record,
            code: record.productCode,
            name: record.productName,
            price: record.price1,
          }));

      return {
        isSelectedRowRetain: false,
        allowResizing: true,
        allowSelection: true,
        // 순서 편집 중에는 열 정렬을 막아 정렬결과를 업무 순서로 오인하지 않도록 함
        allowSorting: !this.isOrderEditable,
        allowRowDragAndDrop: this.isOrderEditable,
        columns: [
          // {
          //   field: "className01",
          //   headerText: "대분류",
          //   textAlign: "Center",
          //   type: "string"
          // },
          // {
          //   field: "className02",
          //   headerText: "중분류",
          //   textAlign: "Center",
          //   type: "string"
          // },
          {
            field: "className03",
            headerText: "소분류",
            textAlign: "Center",
            type: "string",
          },
          {
            field: "name",
            headerText: "상품명",
            textAlign: "Left",
            type: "string",
          },
          {
            field: "code",
            headerText: "상품코드",
            textAlign: "Left",
            type: "string",
          },
          {
            field: "notaxCode",
            headerText: "면/과세",
            allowEditing: false,
            textAlign: "center",
            isCommonCodeField: true,
            groupCode: "NOTAX_CODE",
            type: "string",
          },
          {
            field: "price",
            headerText: "판매금액",
            textAlign: "Right",
            type: "string",
            isNumericType: true,
          },
        ],
        dataSource,
        isInPopup: true,
        provides: [Resize, ForeignKey, RowDD],
        selectionSettings: { type: "Single", enableToggle: false },
        useCommonStyles: false,
      };
    },
  },
  methods: {
    show() {
      this.fetchCommonDepthOneProductCategories();
      this.$refs["dialog"].show();
    },
    hide() {
      this.$refs["dialog"].hide();
    },

    onDialogClose() {
      this.$emit("close");
    },
    onKeypressEnter() {
      this.fetchProductList();
    },
    onSearchClick() {
      this.fetchProductList();
    },
    onProductListGridQueryCellInfo(args) {
      const {
        cell,
        column: { field },
        data,
      } = args;

      if (field === "notaxCode") {
        if (data[field]) {
          cell.style.color = commonCodesGetColorValue(
            "NOTAX_CODE",
            data[field]
          );
        }
      }
    },
    onProductListGridRowDataBound(args) {
      if (args.data.soldoutFlag) {
        args.row.classList.add("dev-soldout-row");
      }
    },
    onProductListGridRecordDoubleClick() {
      const [rowData] = this.$refs["productListGrid"].getSelectedRecords();
      this.$emit("submit", {
        product: rowData,
      });
      this.hide();
    },
    onProductListGridDataBound() {
      if (this.products.length > 0) {
        let selectIndex = 0;
        if (this.orderEditSelectProductCode) {
          const foundIndex = this.products.findIndex(
            (product) =>
              product.productCode === this.orderEditSelectProductCode
          );
          if (foundIndex >= 0) {
            selectIndex = foundIndex;
          }
          this.orderEditSelectProductCode = null;
        }
        this.$refs.productListGrid.selectRow(selectIndex);
      } else {
        this.$refs["input-q"].focus();
      }
    },
    onProductListGridRowDrop(args) {
      if (!this.isOrderEditable) {
        args.cancel = true;
        return;
      }
      const { fromIndex, dropIndex } = args;
      if (typeof fromIndex !== "number" || typeof dropIndex !== "number") {
        return;
      }
      const newProducts = [...this.products];
      const [moved] = newProducts.splice(fromIndex, 1);
      newProducts.splice(dropIndex, 0, moved);
      // products 를 소스로 재바인딩 (그리드는 dataSource 변경으로 순서 반영)
      this.orderEditSelectProductCode = moved.productCode;
      this.products = newProducts;
    },
    onMoveUpClick() {
      this.moveSelectedRow(-1);
    },
    onMoveDownClick() {
      this.moveSelectedRow(1);
    },
    moveSelectedRow(delta) {
      if (!this.isOrderEditable) {
        return;
      }
      const [selected] = this.$refs["productListGrid"].getSelectedRecords();
      if (!selected) {
        this.errorToast("이동할 상품을 선택해 주세요.");
        return;
      }
      const currentIndex = this.products.findIndex(
        (product) => product.productCode === selected.productCode
      );
      const targetIndex = currentIndex + delta;
      if (
        currentIndex < 0 ||
        targetIndex < 0 ||
        targetIndex >= this.products.length
      ) {
        return;
      }
      const newProducts = [...this.products];
      const [moved] = newProducts.splice(currentIndex, 1);
      newProducts.splice(targetIndex, 0, moved);
      this.orderEditSelectProductCode = moved.productCode;
      this.products = newProducts;
    },
    onRestoreOrderClick() {
      // 서버 저장 없이 화면 순서만 원본으로 복원
      this.products = this.originalProducts.slice();
    },
    async onSaveOrderClick() {
      if (!this.isOrderEditable || !this.isOrderChanged) {
        return;
      }

      // 화면 상품들이 원래 점유하던 SORT_NO 슬롯을, 새 순서대로 재배치한다.
      // (목록 밖/필터로 제외된 상품의 슬롯은 건드리지 않아 순서가 보존됨)
      const slots = this.products
        .map((product) => product.storeSortNo)
        .filter((sortNo) => sortNo !== null && sortNo !== undefined)
        .sort((a, b) => a - b);

      if (slots.length !== this.products.length) {
        this.errorToast(
          "일부 상품의 순서 정보가 없어 저장할 수 없습니다. 다시 조회 후 시도해 주세요."
        );
        return;
      }

      const productOrders = this.products.map((product, index) => ({
        productCode: product.productCode,
        order: slots[index],
      }));

      try {
        await putProductOrder(this.store.code, productOrders);
      } catch (e) {
        // 저장 실패: 화면 순서를 확정하지 않는다. (오류 토스트는 인터셉터가 표시)
        // 사용자는 순서 저장 재시도 또는 되돌리기로 원래 순서 복원 가능.
        return;
      }

      this.infoToast("상품 순서를 저장하였습니다.");
      // 성공 후 재조회로 원본 스냅샷 갱신
      await this.fetchProductList();
    },
    onSubmitClick() {
      const [product] = this.$refs["productListGrid"].getSelectedRecords();
      if (!product) {
        return;
      }

      this.$emit("submit", {
        product,
      });
      this.hide();
    },
    onCloseClick() {
      this.hide();
    },

    // API
    async fetchCommonDepthOneProductCategories() {
      this.commonDepthOneProductCategories = _sortBy(
        (await GolfERPService.fetchProductClasses(1)) || [],
        "order"
      );
    },
    async fetchCommonDepthTwoProductCategories(parentCategoryId) {
      this.commonDepthTwoProductCategories = _sortBy(
        (parentCategoryId
          ? await GolfERPService.fetchProductClasses(2, parentCategoryId)
          : []) || [],
        "order"
      );
    },
    async fetchCommonDepthThreeProductCategories(parentCategoryId) {
      this.commonDepthThreeProductCategories = _sortBy(
        (parentCategoryId
          ? await GolfERPService.fetchProductClasses(3, parentCategoryId)
          : []) || [],
        "order"
      );
    },
    async fetchProductList() {
      const {
        value: { productCodes },
      } = await getProductList(
        this.store.code,
        this.selectedCommonDepthOneProductCategoryId || undefined,
        this.selectedCommonDepthTwoProductCategoryId || undefined,
        this.selectedCommonDepthThreeProductCategoryId || undefined,
        this.productNameCode || undefined,
        this.optnFlag,
        false
      );

      this.products = productCodes || [];
      // 편집 전 원본 순서 스냅샷 및 조회 소분류 기록
      this.originalProducts = this.products.slice();
      this.fetchedDepth03Code =
        this.selectedCommonDepthThreeProductCategoryId || null;
      this.orderEditSelectProductCode = null;
    },
  },
};
</script>
